import axios from "axios";
import classNames from 'classnames';
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { ServiceThreadSpinner } from ".";
import { ItemDropdownMenu } from './';
import { api, constants } from "../utils";
import { FaExclamationTriangle } from "react-icons/fa";

const MOS_OPTIONS = {
   One: 1,
   Three: 3,
   Six: 6,
};

const SITE_OPTIONS = {
   Plant: 0,
   Warehouse: 1,
   Hamilton: 2,
};

export default function InventoryDashBoardPMNeedGrid(props) {
   const [data, setData] = useState([]);
   const [hiddenColHeaders, setHiddenColHeaders] = useState([]);
   const [loaded, setLoaded] = useState(false);
   const [monthOpt, setMonthOpt] = useState(1);
   const [params, setParams] = useState({});
   const [siteOpt, setSiteOpt] = useState(0);
   const [payNeeds, setPayNeeds] = useState({
      ABCCode: 0,
      EndDate: "1",
      ItemClass: "",
      ItemDescriptionPartial: "",
      ItemNumber: "",
      ItemNumberStart: "",
      ItemNumberEnd: "",
      ItemOrder: 1,
      SiteId: "PLT",
      VendorNumber: ""
   });

   useEffect(() => {
      if (props.params.selectedItem?.value !== params.selectedItem?.value) {
         setParams(props.params);
         let changes = Object.assign({}, payNeeds);
         changes.ItemNumber = props.params.selectedItem?.value || "";
         setPayNeeds(changes);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.params]);

   useEffect(() => {
      if (payNeeds.ItemNumber.length > 0)
         refreshData();
      else
         setData([]);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [payNeeds]);

   function handleMonthChange(event) {
      const value = parseInt(event.target.value);
      setMonthOpt(value);

      let changes = Object.assign({}, payNeeds);
      if (value === 3)
         changes.EndDate = "3";
      else if (value === 6)
         changes.EndDate = "6";
      else
         changes.EndDate = "1";
      setPayNeeds(changes);
   };

   function handleSiteChange(event) {
      const value = parseInt(event.target.value);
      setSiteOpt(value);

      let changes = Object.assign({}, payNeeds);
      if (value === 1) 
         changes.SiteId = "PLTWHSE";
      else if (value === 2)
         changes.SiteId = "HAMI00";
      else
         changes.SiteId = "PLT";
      setPayNeeds(changes);
   };

   function refreshData() {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      api
         .postS("Inventory/PurchasingNeed", payNeeds, source.token)
         .then((response) => {
            if (response?.data?.success) {
               let colheaders = [];
               if (_.sumBy(response.data.productionData, x => x.hailideQty) > 0) colheaders.push({ displayName: "HAIL01", propertyName: "hailideQty" });
               if (_.sumBy(response.data.productionData, x => x.kolonQty) > 0) colheaders.push({ displayName: "KOLO01", propertyName: "kolonQty" });
               if (_.sumBy(response.data.productionData, x => x.safetyStockQty) > 0) colheaders.push({ displayName: "SSDANA", propertyName: "safetyStockQty" });
               if (_.sumBy(response.data.productionData, x => x.inTransitQty) > 0) colheaders.push({ displayName: "INTRANSIT", propertyName: "inTransitQty" });
               setHiddenColHeaders(colheaders);
               setData(response.data.productionData);
            } else {
               throw new Error(response);
            }
         })
         .catch(() => {
            api.catchHandler();
            setData([]);
         })
         .finally(() => {
            setLoaded(true);
         });
      return () => {
         source.cancel("axios request cancelled");
      };
   };

   function replacer(key, value) {
      // Encode # symbol in item string for inventory dashboard link
      if (typeof value === 'string')
         return value.replace(/#/g, '%23');

      return value;
   }

   return (
      <>
         <Card className="dashboard-card">
            <CardBody>
               <div>
                  <span className="h2 me-2">PM Needs</span>
                  <div className="float-end InLineAttributes">
                     <div>
                        <FormGroup check inline>
                           <Label check>
                              <Input
                                 type="radio"
                                 name="siteOption"
                                 value={SITE_OPTIONS.Plant}
                                 checked={siteOpt === SITE_OPTIONS.Plant}
                                 onChange={handleSiteChange}
                              />{" "}
                              PLT
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check>
                              <Input
                                 type="radio"
                                 name="siteOption"
                                 value={SITE_OPTIONS.Warehouse}
                                 checked={siteOpt === SITE_OPTIONS.Warehouse}
                                 onChange={handleSiteChange}
                              />{" "}
                              PLTWHSE
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check>
                              <Input
                                 type="radio"
                                 name="siteOption"
                                 value={SITE_OPTIONS.Hamilton}
                                 checked={siteOpt === SITE_OPTIONS.Hamilton}
                                 onChange={handleSiteChange}
                              />{" "}
                              HAMI00
                           </Label>
                        </FormGroup>
                     </div>
                     <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                     <div>
                        <FormGroup check inline>
                           <Label check>
                              <Input
                                 type="radio"
                                 name="mosOption"
                                 value={MOS_OPTIONS.One}
                                 checked={monthOpt === MOS_OPTIONS.One}
                                 onChange={handleMonthChange}
                              />{" "}
                              1 Month
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check>
                              <Input
                                 type="radio"
                                 name="mosOption"
                                 value={MOS_OPTIONS.Three}
                                 checked={monthOpt === MOS_OPTIONS.Three}
                                 onChange={handleMonthChange}
                              />{" "}
                              3 Months
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check>
                              <Input
                                 type="radio"
                                 name="mosOption"
                                 value={MOS_OPTIONS.Six}
                                 checked={monthOpt === MOS_OPTIONS.Six}
                                 onChange={handleMonthChange}
                              />{" "}
                              6 Months
                           </Label>
                        </FormGroup>
                     </div>
                  </div>
               </div>
               <hr />
               <ServiceThreadSpinner on={!loaded}>
                  {loaded && data.length !== 0 ? (
                     <div>
                        <Row className="my-3 px-2">
                           <Col xs="2" className="table-header py-1">Item</Col>
                           <Col className="table-header py-1">QC Hold</Col>
                           <Col className="table-header py-1">Required Critical</Col>
                           <Col className="table-header py-1">Needed</Col>
                           <Col className="table-header py-1">Status</Col>
                           <Col className="table-header py-1">PLT</Col>
                           <Col className="table-header py-1">PLTWHSE</Col>
                           {_.isEmpty(hiddenColHeaders) ? null :
                              _.map(hiddenColHeaders, (x, colIdx) => {
                                 return (<Col key={colIdx} className="table-header py-1">{x.displayName}</Col>);
                              })
                           }
                           <Col xs="1" className="custom-table-header-top-right py-1">On Order</Col>
                        </Row>
                        <Row className="mb-1">
                           <Col xs="2">
                              <ItemDropdownMenu
                                 itemNumber={data[0].purchasedItem}
                                 itemDescription={_.trim(data[0].purchasedItemWithDesc)}
                                 attachmentCount={data[0].attachmentCount ?? 0}
                                 colWidth={2}
                                 custom
                              />
                           </Col>
                           <Col>
                              {data[0].purchasedItemHold ? (
                                 <>
                                    <FaExclamationTriangle color="red" />&nbsp;Hold
                                 </>
                              ) : null}
                           </Col>
                           <Col className={classNames("", { "text-brightRed": _.trim(data[0].status) === "Order" })}>
                              {Math.round(data[0].amountRequired).toLocaleString()}
                           </Col>
                           <Col>{Math.round(data[0].amountNeeded).toLocaleString()}</Col>
                           <Col>{data[0].status}</Col>
                           <Col>{Math.round(data[0].plantQty).toLocaleString()}</Col>
                           <Col>{Math.round(data[0].warehouseQty).toLocaleString()}</Col>
                           {_.isEmpty(hiddenColHeaders) ? null :
                              _.map(hiddenColHeaders, (x, idx) => {
                                 return (<Col key={idx}>{Math.round(data[0][x.propertyName]).toLocaleString()}</Col>);
                              })}
                           <Col xs="1" style={{ paddingRight: "0px" }}>{Math.round(data[0].totalOnOrder).toLocaleString()}</Col>
                        </Row>
                        <Table size="sm" className="data-table">
                           <thead className="table-header">
                              <tr>
                                 <th style={{ width: "25%" }}>Item</th>
                                 <th>Build Qty</th>
                                 <th>On Hand</th>
                                 <th>Available</th>
                                 <th>On Order</th>
                                 <th>Order Point</th>
                              </tr>
                           </thead>
                           <tbody>
                              {data[0].children && _.map(data[0].children, (datum, index) => {
                                 return (
                                    <tr key={index}>
                                       <td className="data-cell">
                                          <Link
                                             className="shredLink fw-bold"
                                             to={constants.ENDPOINTS.inventoryDashboard}
                                             onClick={() => localStorage.setItem("itemNumber", JSON.stringify({
                                                label: datum.itemWithDesc,
                                                value: datum.itemnmbr
                                             }, replacer))}
                                             target="_blank"
                                          >
                                             {_.trim(datum.itemWithDesc)}
                                          </Link>
                                       </td>
                                       <td className={"data-cell"}>{Math.round(datum.quantityToBuildPounds).toLocaleString()}</td>
                                       <td className={"data-cell"}>{Math.round(datum.qtyonhnd).toLocaleString()}</td>
                                       <td className={"data-cell"}>{Math.round(datum.available).toLocaleString()}</td>
                                       <td className={"data-cell"}>{Math.round(datum.releaseTotal).toLocaleString()}</td>
                                       <td className={"data-cell"}>{Math.round(datum.ordrpntqty).toLocaleString()}</td>
                                    </tr>
                                 );
                              })}
                           </tbody>
                        </Table>
                     </div>
                  ) : (
                     <div>
                        <span>No PM needs found for the period</span>
                     </div>
                  )}
               </ServiceThreadSpinner>
            </CardBody>
         </Card>
      </>
   );
}
